import { Component, Input } from '@angular/core';
import { Signature } from '@app/core/patient-requests';

@Component({
  selector: 'afoone-signatures',
  template: `
    <div class="signatures">
      <h3>{{'REQUEST_DATA.SIGNATURES' | translate}}</h3>
      <ul>
        <li *ngFor="let firma of signatures">
          <span>{{ firma.name }}</span
          >&nbsp;
          <span>({{ firma.kuerzel }})</span>
        </li>
      </ul>
    </div>
  `,
  styles: [
    `
      .signatures {
        padding: 10px;
      }
    `,
  ],
})
export class SignaturesComponent {
  @Input('signatures') public signatures: Signature[] = [];
}
